import * as React from "react";
import styled, { css } from "styled-components";
import Icon, { IconName } from "../Icon";
import { select, Color } from "@hubper/theme";

type Types = "transparent" | "color";

type BaseProps = {
  disabled?: boolean;
  type: Types;
  size: number;
};

const Base = styled.div<BaseProps>`
  display: inline-block;
  position: relative;
  transition: ${select.speed("fast")};
  z-index: 1;
  padding: 7px;
  cursor: ${p => (p.disabled ? "default" : "pointer")};
  /* pointer-events: ${p => p.disabled && "none"}; */
  width: ${p => p.size};
  height: ${p => p.size};

  ${p =>
    !p.disabled &&
    css`
      &:before {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transition: ${select.speed("fast")};
        z-index: -1;
        content: "";
      }
    `}



  ${p =>
    p.type === "transparent" &&
    css`
      color: ${select.color(["grey", p.disabled ? 1 : 5])};
      &:before {
        background-color: ${select.color(["grey", 1])};
        opacity: 0.5;
        transform: scale(0);
      }

      &:hover {
        color: ${select.color(["grey", p.disabled ? 1 : 9])};
        &:before {
          transform: scale(1);
        }
      }
    `}

  ${p =>
    p.type === "color" &&
    css`
      color: white;
      &:before {
        background-color: ${!p.disabled
          ? select.color(["primary", 5])
          : select.color(["primary", 2])};
      }

      &:hover {
        &:before {
          background-color: ${!p.disabled && select.color(["primary", 7])};
        }
      }
    `}
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  name: IconName;
  onClick?: () => void;
  disabled?: boolean;
  small?: boolean;
  type?: Types;
  c?: Color | string;
};

function IconButton(
  {
    style,
    className,
    name,
    onClick,
    disabled,
    small,
    type = "transparent",
    c
  }: Props,
  ref: any
) {
  return (
    <Base
      disabled={disabled}
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
      type={type}
      size={small ? 20 : 24}
    >
      <Icon name={name} size={small ? 20 : 24} c={c} />
    </Base>
  );
}

export default React.forwardRef(IconButton);
